import styled from 'styled-components'
import TypeScales from './typescales'

interface H5Props {
  noMargin?: boolean
}

export default styled(TypeScales.h5).attrs<H5Props>((props) => ({
  as: 'h5',
  noMargin: props.noMargin || false,
}))<H5Props>`
  text-transform: uppercase;
  margin-bottom: ${({ noMargin }) => (noMargin ? 0 : 0.75)}rem;
`
